import React from 'react';
import './Canvas.css';
import img from '../../assets/images/data-analytics/canvas.png';
import SEO from '../../components/SEO';

const Canvas = () => {
  return (
      <>
          <SEO
              title="Download Our Proprietary AI Scan Canvas for Data Transformation - CloudPlexo"
              description="Explore our AI scan canvas for data-driven transformation. Discover how data recycling can boost efficiency and lower costs in your business"
              keywords="AI Scan Canvas, Data Transformation Tool, Data Recycling Approach, Data Optimization Canvas"
          />

          <div className="download-canvas">
              <nav className="download-canvas-nav">
                  <h2>Download Our Canvas</h2>
              </nav>

              <section className="download-canvas-download">
                  <div className="image-canva">
                      <img
                          src={img}
                          alt="Download Our Proprietary AI Scan Canvas for Data Transformation - CloudPlexo"
                      />
                      <p>
                          Download our proprietary AI scan canvas approach With
                          our tool and canvas method we guide companies through
                          an effective use of the data with the aim of helping
                          clients gain competitive advantage by lowering cost
                          and increasing productivity.
                      </p>

                      <p>
                          Do you consider data driven apprach or AI for your
                          company? Are you curious to see if an investment in
                          data products can lead you to control budgets and
                          increase efficiency? Do you want to see if recycling
                          your data can take your business to the next level?
                      </p>
                  </div>

                  <div className="form-canva">
                      <h3>Download our canvas</h3>

                      <form>
                          <label htmlFor="name">
                              Full Name
                              <input
                                  type="text"
                                  name="name"
                              />
                          </label>

                          <label htmlFor="email">
                              Email
                              <input
                                  type="email"
                                  name="email"
                              />
                          </label>

                          <label htmlFor="number">
                              Phone Number
                              <input
                                  type="text"
                                  name="number"
                              />
                          </label>

                          <label htmlFor="company">
                              Company
                              <input
                                  type="text"
                                  name="company"
                              />
                          </label>

                          <label htmlFor="employee">
                              Number of company employees
                              <input
                                  type="text"
                                  name="employee"
                              />
                          </label>

                          <label htmlFor="country">
                              Country
                              <input
                                  type="text"
                                  name="country"
                              />
                          </label>

                          <button>Download</button>
                      </form>
                  </div>
              </section>
          </div>
      </>
  );
};

export default Canvas;
